/**
 * Icon component for displaying file type icons
 */

import React from 'react';
import { FileText, FileImage, FileSpreadsheet, File } from 'lucide-react';

interface FileIconProps {
  contentType: string;
  size?: number;
}

export const FileIcon: React.FC<FileIconProps> = ({ contentType, size = 18 }) => {
  const getIcon = () => {
    const type = contentType.toLowerCase();

    if (type.includes('pdf')) {
      return <FileText size={size} className="text-red-600" />;
    }
    if (type.includes('image') || type.includes('png') || type.includes('jpg') || type.includes('jpeg')) {
      return <FileImage size={size} className="text-blue-600" />;
    }
    if (type.includes('sheet') || type.includes('excel') || type.includes('csv')) {
      return <FileSpreadsheet size={size} className="text-green-600" />;
    }
    if (type.includes('document') || type.includes('word') || type.includes('doc')) {
      return <FileText size={size} className="text-blue-700" />;
    }
    return <File size={size} className="text-gray-600" />;
  };

  return <div className="flex-shrink-0">{getIcon()}</div>;
};
